import { useCallback } from 'react';
import { get } from 'lodash-es';
import { useApi2call } from 'containers/Api2/index.js';
import parseMeeting from './parseMeeting.js';

function useUpdateMeeting() {
  const api2call = useApi2call();
  return useCallback((meeting, meetingSetId) => {
    const { details, ...body } = meeting;
    const setId = meetingSetId || details.set.id;
    const videoInfo = get(meeting, 'videoMeeting.info');
    if (videoInfo && typeof videoInfo !== 'string') {
      body.videoMeeting.info = JSON.stringify(videoInfo);
    }
    const options = {
      method: 'PUT',
      url: `meetings/sets/${setId}/meetings/${meeting.id}`,
      body,
      parser: parseMeeting,
      withPromise: true,
    };
    return api2call(options);
  }, [api2call]);
}

export default useUpdateMeeting;
